import React from "react";

import styles from "../../ElectoralGeographyPage.module.styl";

const Field = ({ label, value }) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  return (
    <div className={styles.field}>
      <div className={styles.fieldLabel}>{label}</div>
      <div className={styles.fieldValue}>{String(value)}</div>
    </div>
  );
};

export default Field;
